import { lazy, Suspense } from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';
import Home from './views/Home/Home';
import Fleet from './views/Fleet/Fleet';
import Rentals from './views/Rentals/Rentals';
import Activities from './views/Activities/Activities';
import About from './views/About/About';
import Contact from './views/Contact/Contact';
import Commodore from './views/Fleet/Commodore';
import Serenity from './views/Fleet/Serenity';
import Book from './views/Book/Book';
import Consulting from './views/Consulting/Consulting';

const Ops = lazy(() => import('./views/Ops/Ops'));

export const routeList = [
  { path: '/', element: <Home />, title: 'Earthbound Martian | Landships for Rent' },
  { path: '/fleet', element: <Fleet />, title: 'Fleet | Earthbound Martian' },
  { path: '/fleet/commodore', element: <Commodore />, title: 'Commodore — Adventure-Ready Landship | Earthbound Martian' },
  { path: '/fleet/serenity', element: <Serenity />, title: 'Serenity | Earthbound Martian' },
  { path: '/rentals', element: <Rentals />, title: 'Rentals | Earthbound Martian' },
  { path: '/book', element: <Book />, title: 'Book | Earthbound Martian' },
  { path: '/book/:rig', element: <Book />, title: 'Book | Earthbound Martian' },
  { path: '/activities', element: <Activities />, title: 'Activities & Destinations | Earthbound Martian' },
  { path: '/about', element: <About />, title: 'About | Earthbound Martian' },
  { path: '/contact', element: <Contact />, title: 'Contact | Earthbound Martian' },
  { path: '/consulting', element: <Consulting />, title: 'Talk Shop With Chris | Earthbound Martian' },
  { path: '/ops', element: <Ops />, title: 'Ops | Earthbound Martian' },
];

export const AppRoutes = () => (
  <Suspense fallback={null}>
    <RouterRoutes>
      {routeList.map((route) => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}
    </RouterRoutes>
  </Suspense>
);
